module.exports = __webpack_public_path__ + "static/media/FreshSpire-Brandmark_Combination-White.c7f07f53.png";